import PropTypes from 'prop-types';
import React from 'react';

const MessageLabel = ({ text, unreadSeparator }) => {
   if (!text) return null;

   return (
      <div className="message-bubble-wrapper ct-flex ct-fcol ct-aiCenter">
         <div
            className={`chat-label ct-inlineFlex ct-aiCenter ct-jcCenter ${unreadSeparator ? 'unread-separator' : ''}`}
         >
            <span>{text}</span>
         </div>
      </div>
   );
};

MessageLabel.propTypes = {
   text: PropTypes.string,
   unreadSeparator: PropTypes.bool,
};

export default MessageLabel;
